import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Poll } from 'src/app/models/poll.model';
import { School } from 'src/app/models/school.model';
import { EscolarService } from 'src/app/services/escolar.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { SecureStorageService } from 'src/app/services/secure-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-index-polls',
  template: `
    <div class="bg-white p-4 rounded-4 shadow">
      <div class="d-flex mb-2 mb-md-4">
        <img [src]="environment.IMAGES_BASE_URL + (school?.logo?.url || '')" width="18" height="18" class="ms-2" *ngIf="school?.logo?.url">
        <span class="slashy">/</span>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
      <div class="d-flex mb-4">
        <div>
          <h1 class="mb-0">Votaciones <span class="text-muted" style="font-size: 0.5em;">({{meta.total_entries}})</span></h1>
        </div>
        <div class="flex-fill text-end mt-0">
          <div class="float-end">
            <!-- div class="btn-group border border-1 border-secondary me-2" role="group" aria-label="Basic example">
              <button id="btnList" #btnList type="button" class="btn btn-outline-secondary" (click)="selectView('btnList')">
                <fa-icon [icon]="icons.faList"></fa-icon>
              </button>
              <button id="btnBloc" #btnBloc type="button" class="btn btn-outline-secondary" (click)="selectView('btnBloc')">
              <fa-icon [icon]="icons.faGrip"></fa-icon>
              </button>
            </!-->
            <div class="d-inline-block">
              <button class="btn btn-outline-secondary ms-2 border-2" (click)="open()">
                <fa-icon [icon]="icons.faSliders" class="me-0 me-md-2"></fa-icon>
                <span class="d-none d-sm-none d-md-inline-block">Filtrar</span>
              </button>
            </div>
            <button class="btn btn-dark ms-2" routerLink="create">
              <fa-icon [icon]="icons.faPlus" class="me-0 me-md-2"></fa-icon>
              <span class="d-none d-sm-none d-md-inline-block">Agregar votación</span>
            </button>
          </div>
          <div class="form-group float-end me-3" style="width: 200px;">
            <div class="input-group">
              <div class="input-group-addon border border-2 rounded-start-2 border-secondary border-end-0 ps-2 text-secondary" style="padding-top: 7px;">
                <fa-icon [icon]="icons.faSearch" ></fa-icon>
              </div>
              <!-- input class="form-control border-2 border-secondary bg-transparent border-start-0" placeholder="Buscar" -->
              <input id="typeahead-basic" type="text" class="form-control border-2 border-secondary bg-transparent border-start-0" [formControl]="searchControl" />
            </div>
          </div>
        </div>
      </div>      
      <div class="col-12 col-lg-12 offset-lg-0 mt-3 px-2 px-sm-0" *ngIf="activeView=='btnList'">

        <table class="table table-hover table-responsive">
          <thead>
            <tr>
              <th class="bg-light text-secondary align-items-center align-middle rounded-top-left-3"><input type="checkbox" value="" id="flexCheckDefault" [value]="bulkSelect" (change)="bulkSelect = !bulkSelect"></th>
              <th class="bg-light text-secondary align-items-center align-middle text-start">Pregunta</th>
              <th class="bg-light text-secondary align-items-center align-middle rounded-top-right-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr app-tr-polls *ngFor="let poll of polls"></tr>
          </tbody>
        </table>

        <div class="text-center py-5" *ngIf="polls.length==0&&loading">
          <fa-icon [icon]="icons.faCircleNotch" size="4x" animation="spin" class="text-escalas mt-5"></fa-icon>
          <p class="text-muted mt-5">Cargando...</p>
        </div>
        <div class="text-center py-5" *ngIf="polls.length==0&&!loading">
          <img src="/assets/images/empty-state.png" width="240px">
          <h5 class="text-muted">No se encontraron registros</h5>
        </div>
      </div>
      <div class="d-flex justify-content-center">
          <pagination-controls
            (pageChange)="p = $event"
            (pageChange)="pageChanged($event)"
            previousLabel="Prev."
            nextLabel="Sig."
            screenReaderPaginationLabel="Pagination"
            screenReaderPageLabel="page" 
            *ngIf="polls.length>0"                 
          ></pagination-controls>
        </div>
      </div>
  `,
  styles: ``
})
export class IndexPollsComponent implements OnInit {
  @ViewChild('btnList') btnList!: ElementRef;
  @ViewChild('btnBloc') btnBloc!: ElementRef;

  environment = environment;
  school: School | null = null;
  polls: Poll[] = [];
  meta: any = {};
  permissions: any = {};
  loading: boolean = false;
  viewPrefs: any = {};
  prefs: any = {};

  searchControl: FormControl = new FormControl(); 
  
  activeView: string = 'btnList';
  bulkSelect: boolean = false;
  
  payload: any = {
    per_page: 100,
    page: 1,
  };
  p: number = 1;
  
  constructor(
    private readonly escolarService: EscolarService,
    private readonly toastr: ToastrService,    
    public icons: IconsService,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly secureStorage: SecureStorageService
  ) {}

  async initializeComponent(): Promise<void> {
    try {
      // Load data from encrypted storage
      this.permissions = await this.secureStorage.getItem('permissions') || {};
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? schoolData as unknown as School : null;
      this.prefs = await this.secureStorage.getItem('preferences') || {};
      
      // Set active view from preferences
      this.activeView = this.prefs.viewPrefs || 'btnList';
      
      // Set payload school_id if school data is available
      if (this.school?.school_id) {
        this.payload.school_id = this.school.school_id;
      }
    } catch (error) {
      console.error('Error loading component data:', error);
      // Set default values if storage fails
      this.permissions = {};
      this.school = null;
      this.prefs = {};
      this.activeView = 'btnList';
    }
  }

  loadPolls(payload: any) {
    this.loading = true;
    this.escolarService.getPolls(payload).subscribe(
      (response: any) => {
        this.polls = response.data;
        this.meta = response.meta;
        this.loading = false;
      },
      (error: any) => {
        this.toastr.error('Error al cargar las encuestas');
        this.loading = false;
      }
    );
  }

  ngOnInit(): void {
    this.initializeComponent().then(() => {
      this.loadPolls(this.payload);
    });
  }

  open() {
    // Filter functionality to be implemented
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadPolls(this.payload);
  }

}
